import * as React from 'react';
import classnames from 'classnames';
import { withStyles, WithStyles } from '@material-ui/core';

import styles from './AppointmentItemCollapsable.styles';

interface IAppointmentItemCollapsable extends WithStyles<typeof styles> {
  isAppointmentSelected: boolean;
}

const AppointmentItemCollapsable: React.FunctionComponent<IAppointmentItemCollapsable> = (props) => {
  const { children, classes, isAppointmentSelected, ...othersProps } = props;

  const className = classnames(classes.container, { [classes.expand]: isAppointmentSelected });

  return (
    <div className={className} {...othersProps}>
      <div>{children}</div>
    </div>
  );
};

export default withStyles(styles)(AppointmentItemCollapsable);
